import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000"
    height="24"
    width="24"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'bottom' }}
  >
    <path
      d="M7.965 10a.4.4 0 0 0-.37.247.4.4 0 0 0 .087.436l4.035 4.035a.4.4 0 0 0 .566 0l4.035-4.035a.4.4 0 0 0 .087-.436.4.4 0 0 0-.37-.247h-8.07z"
      fill="#1a1a1a"
    />
  </svg>
);
